export default __webpack_public_path__ + "static/image3-4320222a5f2a649010863817e21eeb8d.png";